// @flow

import React from 'react'
import { Marker, Map as GoogleMap, GoogleApiWrapper } from 'google-maps-react'
import type { GoogleParams, Coords } from '../../types'
import styles from './gmapStyle'

type Props = {
    google: ?GoogleParams,
    center: Coords,
}

const Map = ({ center, google }: Props) => (
    <GoogleMap
        styles={styles}
        google={google}
        initialCenter={center}
        center={center}
        zoom={16}
        zoomControl
        zoomControlOptions={{
            position: google && google.maps.ControlPosition.LEFT_TOP,
        }}
        disableDefaultUI
        clickableIcons
    >
        {google && (
            <Marker
                position={center}
                icon={{
                    url: '/resources/marker.png',
                    // $FlowFixMe
                    scaledSize: new google.maps.Size(27, 43),
                }}
            />
        )}
    </GoogleMap>
)

const MapPlaceholder = () => null

export default typeof window === 'undefined' ? MapPlaceholder : GoogleApiWrapper({
    apiKey: 'AIzaSyBrVpvfo4T9BN2Mx3_RFsqw4CWKL7qOIVI',
})(Map)
